import { useState } from "react";
import { NAV_LINKS } from "../../data/constants";
import { useScrolled } from "../../hooks/useScrolled";
import logoSrc from "../../assets/Logo.png";
import styles from "./Navbar.module.css";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const scrolled = useScrolled(40);

  const handleNav = (e, id) => {
    e.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <nav className={`${styles.nav} ${scrolled ? styles.scrolled : ""}`}>
      <div className={styles.inner}>
        <button
          className={styles.logoBtn}
          onClick={() => document.getElementById("hero")?.scrollIntoView({ behavior: "smooth" })}
          aria-label="Home"
        >
          <img src={logoSrc} alt="Royal Horizon Mobility Ltd" className={styles.logoImg} />
          <span className={styles.logoText}>
            Royal <span className={styles.logoGold}>Horizon</span>
          </span>
        </button>

        <ul className={`${styles.links} ${menuOpen ? styles.open : ""}`}>
          {NAV_LINKS.map(({ label, id }) => (
            <li key={id}>
              <a href={`#${id}`} onClick={(e) => handleNav(e, id)}>
                {label}
              </a>
            </li>
          ))}
        </ul>

        <button
          className={styles.cta}
          onClick={() => { document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" }); setMenuOpen(false); }}
        >
          Get a Quote
        </button>

        <button
          className={styles.hamburger}
          onClick={() => setMenuOpen((o) => !o)}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
        >
          <span /><span /><span />
        </button>
      </div>
    </nav>
  );
}
